import { t } from "ttag";

import { CreateSessionButton } from "@/features/coaching/components";
import { Header } from "@/shared/ui";

export const CoachingLabHeader = () => {
  return (
    <Header.Root>
      <div className="flex items-center gap-6">
        <Header.Content className="grow">
          <Header.Title>{t`Coaching lab`}</Header.Title>
        </Header.Content>

        <Header.Actions className="mt-auto p-5">
          <CreateSessionButton position="header" />
        </Header.Actions>
      </div>
    </Header.Root>
  );
};
